import React from 'react';
import PropTypes from 'prop-types';

import { phonePropType } from 'config/propTypes';

import { Link } from 'components/core/Link';
import { Text, Paragraph } from 'components/core/Typography';
import { StarRating } from 'components/review/StarRating';
import { ImageCarousel } from 'components/facility/ImageCarousel';

import './YourStorageFacilityCard.scss';

export function YourStorageFacilityCard({ facility, phone }) {
	return (
		<div className="card">
			<div className="card-header">
				<Text size="small">Your storage facility</Text>
			</div>
			<div className="card-block facility">
				<Paragraph>
					<Link
						to={facility.url}
						className="facility-link"
					>
						{facility.name}
					</Link>
				</Paragraph>
				<Paragraph
					className="address"
					last
				>
					{facility.location.streetAddress1}
					{!!facility.location.streetAddress2 &&
						`, ${facility.location.streetAddress2}`}
					{', '}
					{facility.location.city}
					{', '}
					{facility.location.state} {facility.location.zip}
				</Paragraph>
				{!!phone && (
					<Paragraph>
						<Link href={`tel:${phone.number}`}>
							{phone.formattedNumber}
						</Link>
					</Paragraph>
				)}
				<ImageCarousel
					facility={facility}
					images={facility.images}
					size="large"
				/>
				{facility.reviews && facility.reviews.number > 0 && (
					<div className="facility-review-rating">
						<StarRating rating={facility.reviews.average} />
						<Paragraph>
							Based on <strong>{facility.reviews.number}</strong>{' '}
							storage customer review
							{facility.reviews.number > 1 ? 's' : ''}.
						</Paragraph>
					</div>
				)}
			</div>
		</div>
	);
}

YourStorageFacilityCard.propTypes = {
	facility: PropTypes.object,
	phone: phonePropType,
};

export default YourStorageFacilityCard;
